import { requestCreativeAccess } from './signalr-request-creative-access';

export default {
	data() {
		return {
			creativeIsLockedByOtherUser: false,
			editingLock: null,
		}
	},
	mounted() {
		this.$eventsBus.$on('granted-to-other-user-creative-access', this.onGrantedToOtherUserCreativeAccess);
		this.$eventsBus.$on('received-creative-access', this.onReceivedCreativeAccess);
	},
	destroyed() {
		this.$eventsBus.$off('granted-to-other-user-creative-access', this.onGrantedToOtherUserCreativeAccess);
		this.$eventsBus.$off('received-creative-access', this.onReceivedCreativeAccess);
	},
	methods: {
		async onReceivedCreativeAccess({ creativeId }) {
			if (__DEBUG__)
				console.debug('Received creative access');
			if (this.creative?.Oid === creativeId) {
				await this.loadCreativeJson(true);
				this.checkCreativeEditingLock(true);
			}
		},
		async onGrantedToOtherUserCreativeAccess({ creativeId, userId, userName }) {
			if (__DEBUG__)
				console.debug('Granted to other user creative access');
			if (this.creative?.Oid === creativeId) {
				this.creative.JsonConfig.editingLock = {
					utcTimestamp: this.$Data.getUtcDate(),
					userId: userId,
					userName: userName
				}
				this.creativeIsLockedByOtherUser = true;
				await this.updateCreativeJson();
				this.checkCreativeEditingLock(true);
			}
		},
		checkCreativeEditingLock(preventLoad) {
			if (this.$checkCreativeEditingLockTimer) {
				clearTimeout(this.$checkCreativeEditingLockTimer);
				delete this.$checkCreativeEditingLockTimer;
			}

			if (this._isDestroyed || this.inMemory) return;

			const check = async (creative) => {
				if (!creative) return;
				if (this._isDestroyed || creative?.Oid !== this.creative?.Oid) return;
				if (creative.IsPublished) {
					this.creativeIsLockedByOtherUser = false;
				} else {
					await this.loadCreativeJson();
					let lock = creative.JsonConfig.editingLock;
					let timestamp = lock?.utcTimestamp ? this.$moment(lock.utcTimestamp).utc() : null;

					let newCreativeIsLockedByOtherUser = timestamp && lock?.userId && this.$moment().utc().diff(timestamp, 'seconds') < 60 * 3 && lock?.userId !== this.$auth.userId();
					if (!newCreativeIsLockedByOtherUser) {
						lock = {
							utcTimestamp: this.$Data.getUtcDate(),
							userId: this.$auth.userId(),
							userName: this.$auth.displayUserName()
						};
						this.creative.JsonConfig.editingLock = lock;
					}
					this.creativeIsLockedByOtherUser = newCreativeIsLockedByOtherUser;
					this.$checkCreativeEditingLockTimer = setTimeout(this.checkCreativeEditingLock, (__DEBUG__ ? 30 : 60) * 1000);
					this.editingLock = lock;
				}
			};

			if (!preventLoad) {
				this.$Data
					.getExternalApi('creative/GetCreative', `creativeId=${this.creativeId}`)
					.then((r) => check(r));
			} else {
				check(this.creative);
			}
		},
		removeCreativeLock() {
			if (this.creative && !this.creativeIsLockedByOtherUser) {
				if (__DEBUG__)
					console.debug('Remove creative lock');
				this.creative.JsonConfig.editingLock = {
					userId: null,
					userName: null,
					timestamp: null,
				};
				return this.updateCreativeJson(true);
			}
		},
		requestAccessToCreative() {
			requestCreativeAccess(this.creative);
		}
	}
};
